import { CantileverButton } from 'components/CantileverButton'
import { ChatbotInputCard } from 'features/chatbot/components/ChatbotInputCard'
import { ChatbotDataLayer } from 'features/chatbot/contexts/ChatbotDataLayer'
import { ChatbotUXLayer } from 'features/chatbot/contexts/ChatbotUXLayer'
import { Sparkles, X } from 'lucide-react'
import React, { useState } from 'react'
import styled from 'styled-components'

import { Conversation } from './components/Conversation'
import { useStartScrollFromEndRef } from './hooks/useStartScrollFromEndRef'

const ChatbotContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

const ConversationSection = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.5rem;
`

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  align-items: center;
  cursor: default;
`

const IconAndHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`

const StyledHeader = styled.div`
  color: ${({ theme }) => theme.forecast.defaultText};
  font-size: 1rem;
  font-weight: 600;
`

const ActionsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`

const StyledSparkles = styled(Sparkles)`
  width: 1rem;
  height: 1rem;
  color: ${({ theme }) => theme.forecast.primary};
`

export const Chatbot: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const scrollFromEndRef = useStartScrollFromEndRef<HTMLDivElement>()
  const [delphiHelpModalOpen, setDelphiHelpModalOpen] = useState(false)

  return (
    <ChatbotDataLayer>
      <ChatbotUXLayer>
        <ChatbotContainer>
          <HeaderRow>
            <IconAndHeaderContainer>
              <StyledSparkles />
              <StyledHeader>Cantilever AI</StyledHeader>
            </IconAndHeaderContainer>
            <ActionsContainer>
              <CantileverButton iconOnly ghost onClick={onClose}>
                <X size={16} />
              </CantileverButton>
            </ActionsContainer>
          </HeaderRow>
          <ConversationSection ref={scrollFromEndRef}>
            <Conversation />
          </ConversationSection>
          <ChatbotInputCard
            delphiHelpModalOpen={delphiHelpModalOpen}
            setDelphiHelpModalOpen={setDelphiHelpModalOpen}
          />
        </ChatbotContainer>
      </ChatbotUXLayer>
    </ChatbotDataLayer>
  )
}
